'use strict';

var linchpin = require('int_googletagmanager/linchpin/error');

exports.init = function () {
	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		linchpin.pageErrorEvent();
	}
};

